export default "__VITE_ASSET__CFXqaYxZ__"